// extracted by mini-css-extract-plugin
module.exports = {"logo":"TylDa57wh-_header-footer","monochrome":"azBQYW4Cof_header-footer","invert":"_2RINA2knBe_header-footer"};